import { z } from "zod";

const CharterType = z.enum(["bareboat", "skippered", "crewed"]);
const status = z.enum(["new_enquiry", "automatic_offer_sent", "broker_offer_sent", "draft", "new_booking", "saved"]);
const brands = z.enum(["helm", "anchor"]);
const types = z.enum(["automated", "manual"]);

export const FiltersFormT = z.object({
  charterType: z.array(CharterType).or(z.tuple([])).optional(),
  status: z.array(status).or(z.tuple([])).optional(),
  brand: z.array(brands).or(z.tuple([])).optional(),
  type: z.array(types).or(z.tuple([])).optional(),
  charterStartDate: z.string().or(z.null()).optional(),
  broker: z
    .object({
      firstName: z.string(),
      lastName: z.string(),
      id: z.number(),
      fullName: z.string(),
      email: z.string().optional(),
    })
    .nullable()
    .optional(),
  customer: z
    .object({
      firstName: z.string(),
      lastName: z.string(),
      email: z.string(),
      fullName: z.string(),
    })
    .nullable()
    .optional(),
  endLocation: z.string().optional(),
});

export type FiltersFormT = z.infer<typeof FiltersFormT>;

export const emptyFiltersForm: FiltersFormT = {
  charterType: [],
  status: [],
  brand: [],
  charterStartDate: null,
  endLocation: "",
  customer: null,
  broker: null,
  type: ["manual"],
};
